// @flow
import React from 'react';
import {
  Wrapper,
  LeftPanel,
  Title,
  Lead,
  InnerLeft,
  InnerRight,
  RightPanel,
  VerticalCenter,
  Footer,
  FooterLink,
} from './auth-page-layout.styles';

type Props = {
  footerLinkText: string,
  footerLinkURL: string,
};

export default (props: Props) => (
  <Wrapper>
    <LeftPanel>
      <InnerLeft>
        <VerticalCenter>
          <Title>munity</Title>
          <Lead>Let's build some cool stuff together.</Lead>
        </VerticalCenter>
      </InnerLeft>
      <Footer>
        <FooterLink to={props.footerLinkURL}>{props.footerLinkText}</FooterLink>
      </Footer>
    </LeftPanel>
    <RightPanel>
      <InnerRight>{props.children}</InnerRight>
    </RightPanel>
  </Wrapper>
);



// WEBPACK FOOTER //
// ./src/components/auth-page-layout/index.js